import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useTheme } from 'styled-components'
import CgSearch from '@meronex/icons/cg/CgSearch'
import { Cart3 } from 'react-bootstrap-icons'

import {
  Title,
  WrappLayout,
  WrapContent,
  BusinessContent,
  BusinessCategoryProductWrapper,
  BusinessCategoriesContainer,
  BusinessCartContainer,
  BusinessCartContent,
  EmptyCart,
  EmptyBtnWrapper,
  ProfessionalFilterWrapper,
  WrapperSearchAbsolute,
  AddressBar,
  FixedAddressBar,
  NearBusiness
} from './styles'

import { useLanguage, useConfig, useUtils, useOrder } from '~components'
import { SpinnerCart } from '../Cart/styles'
import { SearchIconWrapper } from '../BusinessBasicInformation/styles'

import {
  useWindowSize,
  scrollTo,
  SpinnerLoader,
  Modal,
  Button,
  Cart,
  BusinessesListing,
  ProfessionalFilter,
  OrderItAgain,
  ProfessionalBusinessFilter,
  BusinessBasicInformation,
  BusinessProductsCategories,
  BusinessProductsList,
  SearchProducts as SearchProductsOriginal,
  CategoriesLayoutGroceries,
  ProductListLayoutGroceries,
  AddressList
} from '~ui'

export const RenderProductsLayout = (props) => {
  const {
    errors,
    isError,
    isLoading,
    business,
    categoryId,
    searchValue,
    sortByValue,
    currentCart,
    businessState,
    sortByOptions,
    categoryState,
    categorySelected,
    openCategories,
    openBusinessInformation,
    isCartOnProductsList,
    handleChangeSortBy,
    errorQuantityProducts,
    handler,
    onClickCategory,
    featuredProducts,
    onProductClick,
    handleSearchRedirect,
    handleChangeSearch,
    setOpenBusinessInformation,
    handleCartOpen,
    isCustomLayout,
    useKioskApp,
    setSubcategoriesSelected,
    subcategoriesSelected,
    isLazy,
    handleUpdateProducts,
    handleChangeProfessionalSelected,
    professionalSelected,
    onBusinessClick,
    handleChangePriceFilterValues,
    priceFilterValues,
    handleUpdateProfessionals,
    isCustomerMode,
    productLoading,
    setProductLoading,
    openAlertErrorStatus,
    onCheckoutRedirect
  } = props

  const theme = useTheme()
  const [, t] = useLanguage()
  useConfig()
  const [{ parsePrice }] = useUtils()
  const [orderState] = useOrder()
  const windowSize = useWindowSize()
  const [isCartModal, setisCartModal] = useState(false)
  const [isAddressModal, setisAddressModal] = useState(false)
  const [openSearchProducts, setOpenSearchProducts] = useState(false)
  const [categoryClicked, setCategoryClicked] = useState(false)
  const [showFixedAddress, setShowFixedAddress] = useState(false)
  const [hideSticky, setHideSticky] = useState(false)
  const addressBarRef = useRef(null)

  const handleAddressScroll = useCallback(() => {
    if (addressBarRef.current) {
      const rect = addressBarRef.current.getBoundingClientRect()
      setShowFixedAddress(rect.bottom < 0)
    }

    const footer = document.querySelector('footer')
    if (footer) {
      const footerRect = footer.getBoundingClientRect()
      setHideSticky(footerRect.top < 150)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleAddressScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleAddressScroll)
  }, [handleAddressScroll])

  const businessLayout = {
    layoutOne: false // force disable groceries layout to use standard layout design
  }
  const showCartOnProductList = !theme?.business_view?.components?.cart?.components?.hidden
  const hideBusinessNearCity = theme?.business_view?.components?.near_business?.hidden ?? true
  const hidePreviousOrdered = theme?.business_view?.components?.products_ordered?.hidden

  const BusinessLayoutCategories = businessLayout.layoutOne
    ? CategoriesLayoutGroceries
    : BusinessProductsCategories

  const BusinessLayoutProductsList = businessLayout.layoutOne
    ? ProductListLayoutGroceries
    : BusinessProductsList

  const handleSaveProduct = () => {
    if (windowSize.width < 993) {
      return
    }
    const productContainer = document.getElementsByClassName('bp-list')[0]
    scrollTo(productContainer, 500, 1250)
  }

  useEffect(() => {
    handleSaveProduct()
  }, [categorySelected])

  useEffect(() => {
    if (windowSize.width < 993 && categoryClicked && document.getElementsByClassName('category-title')) {
      const extraHeight = 80
      const top = document.getElementsByClassName('category-title')[0].offsetTop - extraHeight
      window.scrollTo({
        top,
        behavior: 'smooth'
      })
    } else {
      window.scroll(0, 0)
    }
  }, [categoryClicked])

  return (
    <>
      {showFixedAddress && !isLoading && business?.id && !hideSticky && (
        <FixedAddressBar onClick={() => setisAddressModal(true)}>
          <span>
            {orderState?.options?.address?.address || t('PLEASE_SET_YOUR_LOCATION', 'Please set your location')}
          </span>
        </FixedAddressBar>
      )}
      {!isLoading && business?.id && (
        <WrappLayout isCartOnProductsList={isCartOnProductsList}>
          {((!hideBusinessNearCity && !useKioskApp) || props.forceShowNearBusiness) && !isCustomerMode && !isCustomLayout && (
            <NearBusiness>
              <BusinessesListing
                logosLayout
                propsToFetch={['id', 'logo', 'location', 'timezone', 'schedule', 'open', 'slug']}
                cityId={businessState?.business?.city_id}
                onBusinessClick={onBusinessClick}
                actualSlug={businessState?.business?.slug}
              />
            </NearBusiness>
          )}
          <div className='bp-list'>
            {!useKioskApp && (
              <BusinessBasicInformation
                {...props}
                businessState={businessState}
                setOpenBusinessInformation={setOpenBusinessInformation}
                openBusinessInformation={openBusinessInformation}
                handleChangeSearch={handleChangeSearch}
                searchValue={searchValue}
                sortByOptions={sortByOptions}
                handleChangeSortBy={handleChangeSortBy}
                categoryState={categoryState}
                errorQuantityProducts={errorQuantityProducts}
                sortByValue={sortByValue}
                categoryClicked={categoryClicked}
                categorySelected={categorySelected}
                setCategoryClicked={setCategoryClicked}
              />
            )}

            {!business?.loading && business?.previously_products?.length > 0 && !hidePreviousOrdered && windowSize.width < 993 && !categoryClicked && (
              <OrderItAgain
                onProductClick={onProductClick}
                productList={business?.previously_products}
                businessId={business?.id}
                businessSlug={business?.slug}
              />
            )}
            <div ref={addressBarRef}>
              <AddressBar onClick={() => setisAddressModal(true)}>
                <span>
                  {orderState?.options?.address?.address || t('PLEASE_SET_YOUR_LOCATION', 'Please set your location')}
                </span>
              </AddressBar>
            </div>
            {!businessLayout.layoutOne && (
              <BusinessContent isCustomLayout={isCustomLayout || useKioskApp} id='wrapper-categories'>
                <BusinessCategoryProductWrapper showCartOnProductList={showCartOnProductList}>
                  {business?.professionals?.length > 0 && !useKioskApp && (
                    <>
                      <ProfessionalBusinessFilter
                        sortByOptions={sortByOptions}
                        handleChangeSortBy={handleChangeSortBy}
                        sortByValue={sortByValue}
                        handleChangeSearch={handleChangeSearch}
                        business={business}
                        handleChangePriceFilterValues={handleChangePriceFilterValues}
                        priceFilterValues={priceFilterValues}
                      />
                      <ProfessionalFilterWrapper>
                        <ProfessionalFilter
                          professionals={business?.professionals}
                          professionalSelected={professionalSelected}
                          handleChangeProfessionalSelected={handleChangeProfessionalSelected}
                          handleUpdateProfessionals={handleUpdateProfessionals}
                          cart={currentCart}
                          openAlertErrorStatus={openAlertErrorStatus}
                        />
                      </ProfessionalFilterWrapper>
                    </>
                  )}
                  <div style={{ position: 'relative' }}>
                    {!(business?.categories?.length === 0 && !categoryId) && !categorySelected?.id && (
                      <BusinessLayoutCategories
                        categories={[
                          { id: null, name: t('ALL', theme?.defaultLanguages?.ALL || 'All') },
                          { id: 'featured', name: t('FEATURED', theme?.defaultLanguages?.FEATURED || 'Featured') },
                          ...business?.categories.sort((a, b) => a.rank - b.rank)
                        ]}
                        categorySelected={categorySelected}
                        onClickCategory={onClickCategory}
                        featured={featuredProducts}
                        useKioskApp={useKioskApp}
                        openBusinessInformation={openBusinessInformation}
                        business={business}
                        currentCart={currentCart}
                        wContainerStyle={useKioskApp && 'calc(100% - 50px)'}
                        isProfessional={business?.professionals?.length > 0 && !useKioskApp}
                        hideSticky={hideSticky}
                      />
                    )}
                    {!(business?.categories?.length === 0 && !categoryId) && categorySelected?.id && (
                      <div />
                    )}
                    {useKioskApp && (
                      <WrapperSearchAbsolute id='WrapperSearchAbsolute'>
                        <SearchIconWrapper
                          onClick={() => setOpenSearchProducts(true)}
                        >
                          <CgSearch />
                        </SearchIconWrapper>
                        {openSearchProducts && (
                          <SearchProductsOriginal
                            {...props}
                            businessState={businessState}
                            setOpenBusinessInformation={setOpenBusinessInformation}
                            openBusinessInformation={openBusinessInformation}
                            handleChangeSearch={handleChangeSearch}
                            searchValue={searchValue}
                            sortByOptions={sortByOptions}
                            handleChangeSortBy={handleChangeSortBy}
                            categoryState={categoryState}
                            errorQuantityProducts={errorQuantityProducts}
                            sortByValue={sortByValue}
                            onChange={(val) => handleChangeSortBy && handleChangeSortBy(val)}
                            business={businessState.business}
                            onClose={() => {
                              handleChangeSearch('')
                              setOpenSearchProducts(false)
                            }}
                          />
                        )}
                      </WrapperSearchAbsolute>
                    )}
                  </div>
                  <WrapContent id='businessProductList'>
                    <BusinessLayoutProductsList
                      categories={[
                        { id: null, name: t('ALL', theme?.defaultLanguages?.ALL || 'All') },
                        { id: 'featured', name: t('FEATURED', theme?.defaultLanguages?.FEATURED || 'Featured') },
                        ...business?.categories.sort((a, b) => a.rank - b.rank)
                      ]}
                      isLazy={isLazy}
                      category={categorySelected}
                      categoryState={categoryState}
                      useKioskApp={useKioskApp}
                      businessId={business?.id}
                      errors={errors}
                      onProductClick={onProductClick}
                      handleSearchRedirect={handleSearchRedirect}
                      featured={featuredProducts}
                      searchValue={searchValue}
                      isCartOnProductsList={isCartOnProductsList}
                      handleClearSearch={handleChangeSearch}
                      errorQuantityProducts={errorQuantityProducts}
                      business={business}
                      currentCart={currentCart}
                      setSubcategoriesSelected={setSubcategoriesSelected}
                      subcategoriesSelected={subcategoriesSelected}
                      onClickCategory={onClickCategory}
                      handleUpdateProducts={handleUpdateProducts}
                      professionalSelected={professionalSelected}
                      handleChangeProfessionalSelected={handleChangeProfessionalSelected}
                      previouslyProducts={businessState?.business?.previously_products}
                      onCartRedirect={() => setisCartModal(true)}
                      onCheckoutRedirect={onCheckoutRedirect}
                    />
                  </WrapContent>
                </BusinessCategoryProductWrapper>
                {/* Cart disabled to enforce floating cart at bottom */ (false) && showCartOnProductList && (
                  <BusinessCartContainer isProfessional={business?.professionals?.length > 0 && !useKioskApp}>
                    <BusinessCartContent maxHeight={window.innerHeight - 100}>
                      {currentCart?.products?.length > 0 || (currentCart?.reservation && orderState?.options?.type === 9)
                        ? (
                          <>
                            <Title>{t('YOUR_CART', 'Your cart')}</Title>
                            <Cart
                              isStore
                              isCustomMode
                              isForceOpenCart
                              forceHideCheckoutButton
                              useKioskApp={useKioskApp}
                              cart={currentCart}
                              isCartPending={currentCart?.status === 2}
                              isProducts={currentCart.products.length}
                              isCartOnProductsList={isCartOnProductsList}
                              handleCartOpen={handleCartOpen}
                              businessConfigs={business?.configs}
                              productLoading={productLoading}
                              setProductLoading={setProductLoading}
                            />
                          </>
                          )
                        : (
                          <EmptyCart>
                            <div className='empty-content'>
                              <Cart3 />
                              <p>{t('ADD_PRODUCTS_IN_YOUR_CART', 'Add products in your cart')}</p>
                            </div>
                            <EmptyBtnWrapper>
                              <span>{parsePrice(0)}</span>
                              <Button>{t('EMPTY_CART', 'Empty cart')}</Button>
                            </EmptyBtnWrapper>
                            {productLoading && (
                              <SpinnerCart emptyCart>
                                <SpinnerLoader
                                  style={{ height: 100 }}
                                />
                              </SpinnerCart>
                            )}
                          </EmptyCart>
                          )}
                    </BusinessCartContent>
                  </BusinessCartContainer>
                )}
              </BusinessContent>
            )}

            {businessLayout.layoutOne && (
              <>
                {business?.professionals?.length > 0 && (
                  <ProfessionalFilterWrapper isTop>
                    <ProfessionalFilter
                      professionals={business?.professionals}
                      professionalSelected={professionalSelected}
                      handleChangeProfessionalSelected={handleChangeProfessionalSelected}
                      handleUpdateProfessionals={handleUpdateProfessionals}
                    />
                  </ProfessionalFilterWrapper>
                )}
                <BusinessContent>
                  <BusinessCategoriesContainer offSticky>
                    {!(business?.categories?.length === 0 && !categoryId) && (
                      <>
                        {(!categoryClicked || windowSize.width >= 993) && (
                          <BusinessLayoutCategories
                            component='categories'
                            categories={[
                              { id: null, name: t('ALL', theme?.defaultLanguages?.ALL || 'All') },
                              { id: 'featured', name: t('FEATURED', theme?.defaultLanguages?.FEATURED || 'Featured') },
                              ...business?.categories.sort((a, b) => a.rank - b.rank)
                            ]}
                            categorySelected={categorySelected}
                            onClickCategory={onClickCategory}
                            featured={featuredProducts}
                            openBusinessInformation={openBusinessInformation}
                            openCategories={openCategories}
                            business={business}
                            currentCart={currentCart}
                            useKioskApp={useKioskApp}
                            setCategoryClicked={setCategoryClicked}
                            hideSticky={hideSticky}
                          />
                        )}
                      </>
                    )}
                  </BusinessCategoriesContainer>
                  {(categoryClicked || windowSize.width >= 993) && (
                    <BusinessCategoryProductWrapper>
                      <WrapContent isGroceries id='groceries'>
                        {!business?.loading && !hidePreviousOrdered && business?.previously_products?.length > 0 && windowSize.width >= 993 && (
                          <OrderItAgain
                            onProductClick={onProductClick}
                            productList={business?.previously_products}
                            businessId={business?.id}
                            businessSlug={business?.slug}
                            isGroceries
                          />
                        )}
                        <BusinessLayoutProductsList
                          categories={[
                            { id: null, name: t('ALL', theme?.defaultLanguages?.ALL || 'All') },
                            { id: 'featured', name: t('FEATURED', theme?.defaultLanguages?.FEATURED || 'Featured') },
                            ...business?.categories.sort((a, b) => a.rank - b.rank)
                          ]}
                          category={categorySelected}
                          onClickCategory={onClickCategory}
                          categoriesState={props.categoriesState}
                          categoryState={categoryState}
                          businessId={business?.id}
                          errors={errors}
                          onProductClick={onProductClick}
                          handleSearchRedirect={handleSearchRedirect}
                          featured={featuredProducts}
                          searchValue={searchValue}
                          isCartOnProductsList={isCartOnProductsList && currentCart?.products?.length > 0}
                          handleClearSearch={handleChangeSearch}
                          errorQuantityProducts={errorQuantityProducts}
                          business={business}
                          currentCart={currentCart}
                          handleUpdateProducts={handleUpdateProducts}
                          professionalSelected={professionalSelected}
                          handleChangeProfessionalSelected={handleChangeProfessionalSelected}
                          onCartRedirect={() => setisCartModal(true)}
                          onCheckoutRedirect={onCheckoutRedirect}
                        />
                      </WrapContent>
                    </BusinessCategoryProductWrapper>
                  )}
                </BusinessContent>
              </>

            )}
          </div>
        </WrappLayout>
      )}

      {isLoading && !isError && (
        <>
          {!isCustomLayout && !useKioskApp && (
            <BusinessBasicInformation
              isSkeleton
              handler={handler}
              businessState={{ business: {}, loading: true }}
              openBusinessInformation={openBusinessInformation}
            />
          )}
          <BusinessContent isCustomLayout={isCustomLayout || useKioskApp} id='wrapper-categories'>
            <BusinessCategoryProductWrapper showCartOnProductList={showCartOnProductList}>
              <div style={{ position: 'relative' }}>
                <BusinessProductsCategories
                  isSkeleton
                  categories={[]}
                  openBusinessInformation={openBusinessInformation}
                  isCustomerMode={isCustomerMode}
                />
              </div>
            </BusinessCategoryProductWrapper>
          </BusinessContent>
          {(categoryClicked || windowSize.width >= 993) && (
            <WrapContent>
              <BusinessProductsList
                categories={[]}
                useKioskApp={useKioskApp}
                category={categorySelected}
                categoryState={categoryState}
                isBusinessLoading={isLoading}
                handleUpdateProducts={handleUpdateProducts}
                errorQuantityProducts={errorQuantityProducts}
              />
            </WrapContent>
          )}
        </>
      )}
      {isCartModal && (
        <Modal
          width='40%'
          open={isCartModal}
          onClose={() => setisCartModal(false)}
          padding='0'
        >
          <BusinessCartContent isModal>
            <Title style={{ textAlign: 'center', marginTop: '5px' }}>{t('YOUR_CART', 'Your cart')}</Title>
            {currentCart?.products?.length > 0
              ? (
                <>
                  <Cart
                    isStore
                    isCustomMode
                    isForceOpenCart
                    cart={currentCart}
                    useKioskApp={useKioskApp}
                    isCartPending={currentCart?.status === 2}
                    isProducts={currentCart.products.length}
                    isCartOnProductsList={isCartOnProductsList}
                    handleCartOpen={handleCartOpen}
                    businessConfigs={business?.configs}
                    productLoading={productLoading}
                    setProductLoading={setProductLoading}
                  />
                </>
                )
              : (
                <EmptyCart>
                  <div className='empty-content'>
                    <Cart3 />
                    <p>{t('ADD_PRODUCTS_IN_YOUR_CART', 'Add products in your cart')}</p>
                  </div>
                  <EmptyBtnWrapper>
                    <span>{parsePrice(0)}</span>
                    <Button>{t('EMPTY_CART', 'Empty cart')}</Button>
                  </EmptyBtnWrapper>
                </EmptyCart>
                )}
          </BusinessCartContent>
        </Modal>
      )}
      {isAddressModal && (
        <Modal
          width='70%'
          open={isAddressModal}
          onClose={() => setisAddressModal(false)}
        >
          <AddressList
            isModal
            changeOrderAddressWithDefault
            onCancel={() => setisAddressModal(false)}
            onSaveAddress={() => setisAddressModal(false)}
          />
        </Modal>
      )}
    </>
  )
}
